import adminApi from '../apis/admin';
import { Customer, CustomerType, CustomerFilter, CustomerStats } from '../types/customers';
import axios from 'axios'

// Simulate API delay
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const customerService = {
    // Get all customers with filtering
    getCustomers: async (filter?: CustomerFilter): Promise<{ customers: Customer[], total: number }> => {
        const response = await adminApi.getCustomer(filter);

        if (response.data.length > 0) {
            let filteredCustomers = response.data;
            let pagination = response.pagination;

            return {
                customers: filteredCustomers,
                total: pagination.total
            };
        } else {
            return {
                customers: [],
                total: 0
            };
        }
    },

    // Get customer statistics
    getCustomerStats: async (): Promise<{
        totalUsers: number;
        totalAdmins: number;
        totalOrders: number;
        totalRevenue: number;
    }> => {
        try{
            const response = await adminApi.getStats();
            return response
        } catch (err) {
            console.log('err fetch stats customer ', err)
            return {
                totalUsers: 0,
                totalAdmins: 0,
                totalOrders: 0,
                totalRevenue: 0,
            }
        }
    },

    createCustomer: async (data: any) => {
        console.log(data)
        return adminApi.createCustomer(data);
    },

    updateCustomer: async (id: string, data: any) => {
        console.log('Updating customer:', id, data)
        return adminApi.updateCustomer(id, data);
    },

    deleteCustomer: async (id: string) => {
        console.log('Deleting customer:', id)
        return adminApi.deleteCustomer(id);
    }
};

export default customerService; 